import { useSyncExternalStore } from 'react';

import type { CountryCodeEnum } from '@/enums/country-code-enum';
import { getCountryCodeServerSnapshot, readCountryCode, subscribeCountryCode } from '@/store/country-code-store';

/**
 * The visitor's country, re-rendering when it resolves.
 *
 * `getUserCountryCode()` reads the same store but takes a snapshot and never subscribes, so a component
 * that calls it during render is frozen on whatever was known at mount. That is a race whenever the
 * country decides what gets rendered: the sign-up form uses it to choose the Brazilian phone field and the
 * Russian Telegram field, and a form that mounted before /user/getIp resolved submits `phone: null` — no
 * error, no retry, the number is simply gone.
 *
 * The race predates the request being moved to idle; deferring it only widened the window. This closes it
 * for good, which is why the fix is a subscription rather than putting the request back on the hydration
 * path. Same mechanism `use-captcha-bypass` already uses, and what `get-user-country-code.ts` points at.
 */
export function useCountryCode(): CountryCodeEnum {
  return useSyncExternalStore(subscribeCountryCode, readCountryCode, getCountryCodeServerSnapshot);
}
